import { Injectable, inject } from '@angular/core';

import { PostHogService } from './posthog.service';

type PostHogLogAttributes = Record<string, boolean | number | string>;

@Injectable({
  providedIn: 'root',
})
export class PostHogLogService {
  readonly #posthogService = inject(PostHogService);

  public info(message: string, attributes?: PostHogLogAttributes): void {
    this.#posthogService.posthog.logger?.info?.(message, attributes);
  }
}
